import { Box } from '@mui/material';

// Invisible view that will render a hidden scroll bar to align content (ex: a header) with a scrollable content.
export function ScrollbarSpacer() {
  return <Box sx={{ visibility: 'hidden', overflowY: 'scroll' }} />;
}
